import { useEffect } from 'react'

const PIXEL_ID = '25176507425343433'

let pixelLoaded = false

function loadPixelScript(): void {
  if (pixelLoaded) return
  pixelLoaded = true

  try {
    const w = window as any
    if (w.fbq) return

    const fbq: any = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args)
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    w.fbq = fbq
    w._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    w.fbq('init', PIXEL_ID)
    w.fbq('track', 'PageView')
  } catch (e) {
    console.warn('Meta Pixel failed to load:', e)
  }
}

export function fireAddToCart(): void {
  try {
    const w = window as any
    if (w.fbq) {
      w.fbq('track', 'AddToCart')
    }
  } catch (e) {
    console.warn('Meta Pixel AddToCart failed:', e)
  }
}

export function useMetaPixel(): void {
  useEffect(() => {
    loadPixelScript()
  }, [])
}
